import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { guestOpacApi, type GuestOpacResourceSummary } from "@/lib/api/guest-opac";
import { GuestCatalogSectionHeader } from "@/components/guest-catalog/GuestCatalogSectionHeader";
import { GuestCatalogSectionCard } from "@/components/guest-catalog/GuestCatalogSectionCard";
import { GuestCatalogItemView } from "@/components/guest-catalog/GuestCatalogItemView";
import { GuestCatalogCardsSkeleton } from "@/components/guest-catalog/GuestCatalogSkeleton";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";

interface GuestCatalogHighlightsProps {
  tenantSlug: string;
  viewMode: GuestCatalogViewMode;
  loading?: boolean;
}

export function GuestCatalogHighlights({
  tenantSlug,
  viewMode,
  loading: externalLoading,
}: GuestCatalogHighlightsProps) {
  const [items, setItems] = useState<GuestOpacResourceSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    guestOpacApi
      .getHighlights(tenantSlug)
      .then((data) => {
        if (!cancelled) setItems(data);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantSlug]);

  const showSkeleton = loading || externalLoading;

  if (!showSkeleton && items.length === 0) return null;

  return (
    <GuestCatalogSectionCard>
      <section className="space-y-4">
        <GuestCatalogSectionHeader
          title="New in the Catalog"
          icon={Sparkles}
          description={showSkeleton ? undefined : "Recently added published titles"}
        />
        {showSkeleton ? (
          <GuestCatalogCardsSkeleton count={4} />
        ) : (
          <GuestCatalogItemView items={items} viewMode={viewMode} tenantSlug={tenantSlug} />
        )}
      </section>
    </GuestCatalogSectionCard>
  );
}
